import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @jsx jsx */


import { jsx, Container } from 'theme-ui';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var MainContainer = function MainContainer(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return jsx(Container, _extends({
    sx: styles.container
  }, rest), children);
};

if (typeof MainContainer !== 'undefined' && MainContainer && MainContainer === Object(MainContainer) && Object.isExtensible(MainContainer) && !MainContainer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(MainContainer, '__filemeta', {
    configurable: true,
    value: {
      name: "MainContainer",
      filename: "../../node_modules/gatsby-theme-docz/src/components/MainContainer/index.js"
    }
  });
}